import React from 'react';
import c from 'classnames';
import { useTranslation } from 'react-i18next';

import { SearchSortBy } from '@uncinc/react-searchkit';
import type { SearchSortByProps } from '@uncinc/react-searchkit/dist/components/SortBy';

import { APP_OPTIONS } from '../../../config/constants';

import './style.scss';

const SearchAllContentSortBy: React.FC<Omit<SearchSortByProps, 'items' | 'placeholder' | 'inputType'>> = (props) => {
  const { className, ...restProps } = props;

  const { t } = useTranslation();

  const classNames = c('SearchAllContent__SortBy', className);

  return (
    <SearchSortBy
      {...restProps}
      inputType="radios"
      className={classNames}
      placeholder={t('components.search_all_content.sort_by.placeholder')}
      items={[
        {
          label: t('components.search_all_content.sort_by.items.score'),
          value: APP_OPTIONS.parameters.searchkitIndexAllContent,
        },
        {
          label: t('components.search_all_content.sort_by.items.bibcite_year'),
          value: `${APP_OPTIONS.parameters.searchkitIndexAllContent}_bibcite_year`,
        },
      ]}
    />
  );
};

export default SearchAllContentSortBy;
